import ApiRequest from './apiRequest';

class SelectionsService {
  static async getSelections() {
    const data = await ApiRequest.apiRequest(
      {method: 'GET', url: `selections`}
    );
    return data;
  };

  static async getSelectionVersion(id) {
    const data = await ApiRequest.apiRequest(
      {method: 'GET', url: `selections/${id}`, getVersion: true}
    );
    return data;
  };

  static async addSelectionList(payload) {
    const data = await ApiRequest.apiRequest(
      {method: 'POST', url: `selections`, body: payload, noResponse: true}
    );
    return data;
  };

  static async updateSelectionList(payload, id, version) {
    const data = await ApiRequest.apiRequest(
      {method: 'PUT', url: `selections/${id}`, body: payload, noResponse: true, version: version}
    );
    return data;
  };

  static async deleteSelectionList(id) {
    const data = await ApiRequest.apiRequest(
      {method: 'DELETE', url: `selections/${id}`, noResponse: true}
    );
    return data;
  };
}

export default SelectionsService;
